import ApiService from '../../../../../services/ApiService'
import CalibrationDataTable from '../CalibrationDataTable/CalibrationDataTable.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
import moment from 'moment'

import Utils from '../../../../../Utils/FormatDate'

export default {
  components: {
    CalibrationDataTable,
    DepartmentInactive,
    SignatureScreen,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.currentServiceOrder = JSON.parse(
      sessionStorage.getItem('serviceOrder')
    )
    this.inputDisabled =
      this.institution.userType > 3 && this.institution.userType != 8
    this.getTemplates()
    if (this.currentServiceOrder.calibrations.length > 0) {
      this.getCalibration()
    }
    this.getCalibrationMetrics()
    this.getCalibrationPatterns()

    await this.getInstitution()

    this.footnote = this.institution.calibrationFootNote
      ? this.institution.calibrationFootNote
      : `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157`
  },

  data: () => ({
    institution: {},
    nextDateMenu: false,
    nextDate: null,
    option: 0,
    signatureConfirmDialog: false,
    selectedPatterns: [],
    institutionId: '',
    step: 0,
    selectedTab: 0,
    errorMessage: '',
    successMessage: '',
    inputDisabled: false,
    loading: false,
    deleteDialog: false,
    templateLoading: false,
    deleteLoading: false,
    firstValid: true,
    alterDialog: false,
    signatureErrorDialog: false,
    printDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    showSuccess: false,
    departmentInactive: false,
    withoutValues: false,
    withoutValuesDialog: false,
    calibrationDateTimeError: false,
    tab: null,
    calibrationDateTime: null,
    resolutionEquipment: null,
    footnote: null,
    currentServiceOrder: {},
    currentCalibrationPatternTemplate: null,
    calibrationPatternTemplates: [],
    calibrationMetrics: [],
    calibrationTemplateParameters: [],
    calibrationMetricsRanges: [],
    calibrationParameters: [],
    currentUser: {},
    currentCalibration: {
      id: 0,
      calibrationDate: null,
      temperature: `25,00 ${String.fromCharCode(177)} 0,50 C`,
      relativeHumidity: `55,00 ${String.fromCharCode(177)} 5,00 %`,
      isExecutingSigned: false,
      executingUserId: null,
    },
    footnoteRules: [(v) => !!v || 'Rodapé é obrigatório'],
    apiService: new ApiService(),
    expiredPatternDialog: false,
    expiredPatternsCount: 0,
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    formatMonth(date) {
      return date ? moment(date).format('MM/YYYY') : ''
    },

    async getInstitution() {
      await this.apiService
        .get(`institution/${this.institutionId}`)
        .then((response) => {
          this.institution = response.content
        })
    },

    close() {
      sessionStorage.clear()
      let router = '/calibration'
      if (this.institution.userType > 4 && this.institution.userType != 8) {
        this.changedData = false
        router = '/serviceorders'
      }

      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push(router)
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    setCalibrationNowDate() {
      this.calibrationDateTime = !this.calibrationDateTime
        ? new Date()
        : this.calibrationDateTime
    },

    editCalibrationData() {
      this.$router.push(`/calibrationCertified/${this.currentServiceOrder.id}`)
    },

    async openCertified() {
      if (this.withoutValues) {
        this.withoutValuesDialog = true
      } else {
        const route = this.$router.resolve({
          path: `printCalibrationCertified/${this.currentServiceOrder.institutionId}/${this.currentCalibration.id}`,
        })
        window.open(route.href, '_blank')
      }
    },

    showSuccessAlert(message) {
      this.successMessage = message
      this.showSuccess = true
      this.deleteDialog = false

      setTimeout(() => {
        this.showSuccess = false
      }, 2000)
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    getMetricUnit(id) {
      return this.calibrationMetrics.find((x) => x.id === id).unit
    },

    getCalibrationPatternName(id) {
      return this.calibrationPatterns.find((x) => x.id === id).name
    },

    signCalibration() {
      if (this.withoutValues) {
        this.withoutValuesDialog = true
      } else {
        if (this.currentUser.signatureImage) {
          this.currentCalibration.isExecutingSigned = true
          this.currentCalibration.executingUserId = this.currentUser.id
          this.submit()
        } else {
          this.signatureErrorDialog = true
        }
      }
    },

    openSignatureModel() {
      if (this.$refs.firstForm.validate() && this.calibrationDateTime) {
        this.signatureConfirmDialog = true
      } else {
        this.calibrationDateTime
          ? (this.calibrationDateTimeError = false)
          : (this.calibrationDateTimeError = true)

        if (this.calibrationDateTimeError) {
          this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
        }
      }
    },

    async validateCalibration(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          this.currentCalibration.isExecutingSigned = true
          this.currentCalibration.executingUserId = this.currentUser.id
          this.currentCalibration.executingImage = null
          this.signatureConfirmDialog = false
          this.submit()
        } else {
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        this.currentCalibration.isExecutingSigned = true
        this.currentCalibration.executingUserId = this.currentUser.id
        this.currentCalibration.executingImage = data
        this.submit()
        this.signatureConfirmDialog = false
      } else {
        if (
          this.currentServiceOrder &&
          this.currentServiceOrder &&
          this.currentServiceOrder.responsibleName
        ) {
          this.apiService
            .get(`byName/${this.currentServiceOrder.responsibleName}`)
            .then((response) => {
              this.currentCalibration.isExecutingSigned = true
              this.currentCalibration.executingUserId = response.content.id
              this.currentCalibration.executingImage = null
              this.signatureConfirmDialog = false
              this.submit()
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    async getCalibration() {
      await this.apiService
        .get(
          `calibration/getByServiceOrder/${this.currentServiceOrder.institutionId}/${this.currentServiceOrder.id}`
        )
        .then((response) => {
          if (response.content) {
            this.isEditing = true
            this.currentCalibration = response.content
            this.calibrationDateTime = this.currentCalibration.calibrationDate
            this.currentCalibrationPatternTemplate =
              this.currentCalibration.calibrationPatternTemplate
            this.departmentInactive =
              response.content.equipment.department.status == 1
            this.footnote =
              response.content.footnote != null
                ? response.content.footnote
                : `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157`

            if (this.currentCalibration.nextCalibrationDate) {
              this.nextDate = this.currentCalibration.nextCalibrationDate
                ? moment(
                    this.currentCalibration.nextCalibrationDate.split('T')[0]
                  ).format('YYYY-MM')
                : ''
            }

            if (!this.nextDate) {
              this.nextDate = this.calibrationDateTime
                ? moment(this.calibrationDateTime.split('T')[0])
                    .add(1, 'y')
                    .format('YYYY-MM')
                : ''
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/calibration')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCalibrationMetrics() {
      await this.apiService.get('calibrationMetrics/list').then((response) => {
        this.calibrationMetrics = response.content
      })
    },

    async getCalibrationPatterns() {
      await this.apiService.get('calibrationPattern/list').then((response) => {
        this.calibrationPatterns = response.content
      })
    },

    async checkIfHaveExpiredPatterns(template) {
      const patterns = template.calibrationPatternTemplate.parameters.map(
        (x) => x.calibrationPattern
      )
      this.selectedPatterns = patterns.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.place === value.place && t.name === value.name
          )
      )

      await this.apiService
        .get(
          `calibrationPatternTemplate/expiredPatterns/${template.calibrationPatternTemplate.id}`
        )
        .then((response) => {
          const expiredPatterns = response.content
          if (expiredPatterns && expiredPatterns.length > 0) {
            this.expiredPatternDialog = true
            this.expiredPatternsCount = expiredPatterns.length
          }
        })
    },

    async getTemplates() {
      this.templateLoading = true

      const standardEquipId =
        this.currentServiceOrder.equipment != null &&
        this.currentServiceOrder.equipment.standardEquipment != null
          ? this.currentServiceOrder.equipment.standardEquipment
              .standardEquipmentId
          : 0

      const model = {
        StandardEquipmentId: standardEquipId,
        InstitutionId: this.currentServiceOrder.institutionId,
      }

      await this.apiService
        .post('calibrationPatternTemplate/listTemplate', model)
        .then((response) => {
          this.calibrationPatternTemplates = response.content
          this.templateLoading = false
        })
    },

    async submit() {
      if (this.$refs.firstForm.validate() && this.calibrationDateTime) {
        this.loading = true

        const calibration = {
          Id: this.currentCalibration.id,
          InstitutionId: this.currentServiceOrder.institutionId,
          EquipmentId: this.currentServiceOrder.equipmentId,
          calibrationPatternTemplateId: this.isEditing
            ? this.currentCalibrationPatternTemplate.id
            : this.currentCalibrationPatternTemplate.calibrationPatternTemplate
                .id,
          ServiceOrderId: this.currentServiceOrder.id,
          CalibrationDate: Utils.nowDatetimeFormat(this.calibrationDateTime),
          Temperature: this.currentCalibration.temperature,
          RelativeHumidity: this.currentCalibration.relativeHumidity,
          isExecutingSigned: this.currentCalibration.isExecutingSigned,
          ExecutingUserId: this.currentCalibration.executingUserId,
          isValidatorSigned: this.currentCalibration.isValidatorSigned,
          ValidatorUserId: this.currentCalibration.validatorUserId,
          Footnote: this.footnote,
          Result: this.currentCalibration.result,
          ExecutorName: this.currentCalibration.executorName,
          ExecutingImage: this.currentCalibration.executingImage,
        }

        let calibrationModel = null
        if (!this.isEditing) {
          const parameters =
            this.$refs.calibrationDataTable.calibrationTemplateParameters.filter(
              (x) => x.ResolutionEquipment
            )
          calibrationModel = {
            Calibration: calibration,
            Ranges:
              this.$refs.calibrationDataTable.calibrationParameterMetricRanges,
            Parameters: parameters,
          }
        }

        let url = 'calibration/add'

        if (this.isEditing) {
          url = 'calibration/edit'
        }

        await this.apiService
          .post(url, this.isEditing ? calibration : calibrationModel)
          .then((response) => {
            this.$toast.success('Calibração salva com sucesso!')
            this.closeDialog()
            this.showSuccessAlert(response.message)
            this.institutionId

            if (!this.isEditing) {
              const route = this.$router.resolve({
                path: `printCalibrationCertified/${this.currentServiceOrder.institutionId}/${response.entityId}`,
              })
              window.open(route.href, '_blank')
            }

            this.$router.push(
              `/editServiceOrder/${this.currentServiceOrder.id}`
            )

            this.loading = false
          })
          .catch((err) => {
            this.loading = false
          })
      } else {
        this.calibrationDateTime
          ? (this.calibrationDateTimeError = false)
          : (this.calibrationDateTimeError = true)

        if (this.calibrationDateTimeError) {
          this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
        }
      }
      this.loading = false
    },

    async removeCalibrationData() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibration/delete', this.currentCalibration)
        .then((response) => {
          this.deleteLoading = false
          this.showSuccessAlert('Valores da calibração removido com sucesso')
          window.scrollTo(0, 0)
          this.currentCalibration = {}
          this.currentCalibrationPatternTemplate = {
            calibrationPatternTemplate: {},
          }
          this.isEditing = false
        })
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
  },

  watch: {
    currentCalibration: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    calibrationDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.nextDate = this.calibrationDateTime
          ? moment(this.calibrationDateTime).add(1, 'y').format('YYYY-MM')
          : ''
        this.calibrationDateTimeError = false
      },
    },
  },
}
